import Error from '@/includes/Error'

export default abstract class Validator {
    abstract isValid(): Error;
    abstract setTargerForValidation(target: any): Validator
}